import { useTranslation } from "react-i18next";
import { useTheme } from "@mui/material";
import { OcRoleFilterSummaryItemProps } from "./role-filter-summary-item";
import { useMapToTheme } from "oc/hooks";

export const useOcRoleFilterSummaryItem = ({
  label,
  color,
}: Omit<OcRoleFilterSummaryItemProps, "value">) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const { mapToTheme } = useMapToTheme();

  let valueColor = theme.palette.gray80.main;
  if (color) valueColor = mapToTheme(color);
  const translatedLabel = t(label);
  return {
    translatedLabel,
    valueColor,
  };
};
